import { render, staticRenderFns } from "./district.vue?vue&type=template&id=21e0d0b8&scoped=true"
import script from "./district.vue?vue&type=script&lang=js"
export * from "./district.vue?vue&type=script&lang=js"
import style0 from "./district.vue?vue&type=style&index=0&id=21e0d0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0d0b8",
  null
  
)

export default component.exports